export default __webpack_public_path__ + "static/media/logo.f38b755b.svg";